function initTurboForms(forms) {
	$(forms).each(function (index, item) {
		const turboForm = new TurboForm(item, {
			errorBoxSelector: '.js-error-box'
		});

		initTurboUploader(item)

		turboForm.showSuccessMessage = function (message) {
			$(this.form).slideUp();
			$(this.form.previousElementSibling).slideUp();
			const successBlock = $(this.form.nextElementSibling);
			successBlock.find('.remodal__descr').html(message);
			successBlock.slideDown();
		};

		turboForm.showErrorMessage = function (message) {
			if (this.errorBox) {
				this.errorBox.textContent = message;
				this.errorBox.style.display = 'block';
			}
		};
	})
}


function initTurboUploader(form) {
	const uploaders = $(form).find('.js-uploader')
	if (uploaders.length) {
		$(uploaders).each(function (index, uploader) {
			new TurboUploader(uploader)
		})
	}
}

initTurboForms($(".js-form"))
